<script lang="ts">
import { defineComponent, ref, h, withDirectives, onMounted, watch, PropType } from 'vue';
import visibilityDirective from 'Helpers/directives/visibility';
import { useLogin } from 'Store';

export default defineComponent({
  name: 'ControlRender',
  props: {
    timeout: {
      type: Number as PropType<number>,
    },
    whenTrue: Boolean,
    whenLoggedIn: Boolean,
    whenPrerender: Boolean,
    whenVisible: Boolean,
    visibilityTopMargin: {
      default: '0px',
      type: String,
    },
    excludedForPrerender: Boolean,
  },
  emits: ['render'],
  setup(props, { emit }) {
    const isRender = ref(false);
    let timeoutId = 0;
    const { isLoggedIn } = useLogin();

    function setRender() {
      if (window.__prerender && props.excludedForPrerender) return;
      isRender.value = true;
      emit('render');
      clearTimeout(timeoutId);
    }

    function getStub() {
      const stub = h('div', {
        class: 'control-render',
        style: 'position:absolute;visibility:hidden;height:0px;width:0px;',
      });
      return withDirectives(stub, [
        [visibilityDirective, setRender, props.visibilityTopMargin],
      ]);
    }

    watch(() => props.whenTrue, (whenTrue) => {
      if (whenTrue) setRender();
    });

    if (props.whenLoggedIn) {
      if (isLoggedIn.value) setRender();
      else {
        watch(isLoggedIn, () => {
          if (isLoggedIn.value) setRender();
        });
      }
    }

    if (props.whenPrerender && window.__prerender) {
      setRender();
    }
    onMounted(() => {
      if (props.timeout) {
        timeoutId = setTimeout(setRender, props.timeout);
      }
    });

    return {
      getStub,
      isRender,
      isLoggedIn,
    };
  },
  render() {
    if (this.isRender) return this.$slots?.default?.();
    if (this.whenVisible) return this.getStub();
    return null;
  },
});
</script>
